import { useIsPlatform } from '@/shared/session/currentUser';

/**
 * What the server said, folded away: the screen shows the sentence for a person, and
 * whoever has to fix the failure opens this. Never the only message.
 *
 * **Only for superadministrators** since contract v10.31: the raw text names the model,
 * the mail server, the exception, and Eloy decided on 2026-10-02 that the people of the
 * shop do not get the internal information, a code at most. Everybody else sees nothing
 * here; the sentence above it is the message.
 */
export function TechnicalDetails({ text }: { text: string | null | undefined }) {
  const platform = useIsPlatform();
  if (!platform || !text) return null;
  return (
    <details className="mt-1">
      <summary className="cursor-pointer text-[12.5px] select-none">Detalles técnicos</summary>
      <code className="mt-1 block font-mono text-[12px] break-all opacity-80">{text}</code>
    </details>
  );
}

/** The stable code of a failure, small, to read out to whoever administers it. */
export function FailureCode({ code }: { code: string | null | undefined }) {
  if (!code) return null;
  return (
    <span className="text-ink-3 mt-1 block text-[12px]">
      Código: <span className="font-mono">{code}</span>
    </span>
  );
}
